import { Component, ChangeDetectionStrategy, inject, computed, input, OnInit, DestroyRef } from '@angular/core';
import { takeUntilDestroyed, toObservable, toSignal } from '@angular/core/rxjs-interop';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DmsBaseFolderAction } from '@iris/common/modules/dms/components/actions/folder-actions/dms-base-folder-action';
import { IrisDmsFilesSandbox } from '@iris/common/modules/dms/sandbox/dms-files.sandbox';
import { IrisDmsPermissionsSandbox } from '@iris/common/modules/dms/sandbox/dms-permissions.sandbox';
import { IrisDmsTrashBinStore } from '@iris/common/modules/dms/store/trash-bin.signal-store';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { filter, switchMap } from 'rxjs';
import { StrakitButtonComponent } from '@ngx-strakit/cdk/controls';
import { StrakitButtonPrefixDirective } from '@ngx-strakit/cdk';
import { MatMenuItem } from '@angular/material/menu';

@Component({
  selector: 'iris-dms-trash-bin-restore-button',
  imports: [
    TranslatePipe,
    MatTooltipModule,
    StrakitButtonComponent,
    StrakitButtonPrefixDirective,
    MatMenuItem,
  ],
  templateUrl: './dms-trash-bin-restore-button.component.html',
  styleUrls: ['./dms-trash-bin-restore-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IrisDmsTrashBinRestoreButtonComponent extends DmsBaseFolderAction implements OnInit {
  private readonly dmsTrashBinStore = inject(IrisDmsTrashBinStore);
  private readonly dmsPermissionsSandbox = inject(IrisDmsPermissionsSandbox);
  private readonly dmsFilesSandbox = inject(IrisDmsFilesSandbox);
  private readonly destroyRef = inject(DestroyRef);
  protected readonly translateService = inject(TranslateService);

  readonly fileId = input<string>();
  private readonly fileId$ = toObservable(this.fileId);
  private readonly fileParentId$ = this.fileId$.pipe(
    filter(Boolean),
    switchMap((fileId) => this.dmsFilesSandbox.getFileParentId$(fileId)),
  );
  private readonly fileParentId = toSignal(this.fileParentId$);

  readonly hasFolderUpdaePermissions = computed(() => {
    return this.dmsPermissionsSandbox.hasUpdatePermissionForFolderId(this.folderId() || this.fileParentId())();
  });

  public readonly buttonDisabled = computed(() => !this.dmsTrashBinStore.hasAnySelection() && !this.iconOnly || !!this.folderId() && !this.hasFolderUpdaePermissions());

  ngOnInit(): void {
    (this.folderId() ? this.folderId$ : this.fileParentId$).pipe(
      filter(Boolean),
      switchMap(folderId => this.dmsPermissionsSandbox.getUserAvailableActions$(folderId)),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe();
  }

  restore(): void {
    this.dmsTrashBinStore.restoreSelectedEntities$(this.folderId() || this.fileId());
  }
}
